import { useToaster } from "react-hot-toast/headless";
import { Notification } from "./Notification";

export const Notifications = () => {
  const { toasts } = useToaster({
    duration: 2000,
    error: {
      duration: Infinity,
    },
  });

  return (
    <>
      <div className="fixed top-20 md:top-16 left-2 right-2 bottom-2 z-[5000] pointer-events-none flex flex-col space-y-4 items-center">
        {toasts
          .filter((toast) => toast.visible)
          .map((toast) => <Notification key={toast.id} {...toast}/>)}
      </div>
    </>
  );
};
